// src/pages/SplashScreen.js

import React from 'react';
import styled from 'styled-components';
// [변경] CSS 파일 제거
// import './SplashScreen.css';

// 스플래시 컨테이너 스타일
const SplashContainer = styled.div`
  width: 100%;
  height: 100vh;
  /* [핵심] background-image를 props로 받아서 적용 */
  background-image: ${props => `url(${props.$backgroundImageUrl})`};
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 15vh;
  box-sizing: border-box;
  /* 페이드인 애니메이션 추가 */
  opacity: ${props => props.$isLoaded ? 1 : 0};
  transition: opacity 0.5s ease-in-out;
`;

// 로딩바 컨테이너
const LoadingBarContainer = styled.div`
  width: 60%;
  height: 12px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

// 로딩바 채우기
const LoadingBarFill = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, ${props => props.theme.colors.gold}, ${props => props.theme.colors.goldDark});
  border-radius: 6px;
  /* 1.5초 동안 바가 채워지는 애니메이션 */
  animation: fillAnimation 1.5s ease-out forwards;
  
  @keyframes fillAnimation {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

// 로딩 텍스트
const LoadingText = styled.div`
  margin-top: 1rem;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
`;

const SplashScreen = () => {
  // [핵심] Create React App의 환경 변수인 `process.env.PUBLIC_URL`을 사용합니다.
  // 이 변수는 앱이 어떤 경로에 배포되더라도 항상 public 폴더를 가리키는 정확한 경로를 보장합니다.
  const webpImageUrl = `${process.env.PUBLIC_URL}/splash.webp`;
  const pngImageUrl = `${process.env.PUBLIC_URL}/splash.png`;
  const [backgroundImageUrl, setBackgroundImageUrl] = React.useState(webpImageUrl);
  
  // 이미지가 로드되었는지 확인하기 위한 상태 (선택사항)
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);
  
  React.useEffect(() => {
    let cancelled = false;
    let activeImage;
    let fallbackStarted = false;

    const showImage = (url) => {
      if (cancelled) return;
      setBackgroundImageUrl(url);
      setIsImageLoaded(true);
    };

    const loadImage = (url, onFailure) => {
      const img = new Image();
      activeImage = img;
      img.onload = () => {
        if (typeof img.decode === 'function') {
          img.decode().then(() => showImage(url)).catch(onFailure);
        } else {
          showImage(url);
        }
      };
      img.onerror = onFailure;
      img.src = url;
    };

    const fallbackToPng = () => {
      if (cancelled || fallbackStarted) return;
      fallbackStarted = true;
      loadImage(pngImageUrl, () => {});
    };

    loadImage(webpImageUrl, fallbackToPng);
    return () => {
      cancelled = true;
      if (activeImage) {
        activeImage.onload = null;
        activeImage.onerror = null;
      }
    };
  }, [webpImageUrl, pngImageUrl]);

  return (
    // CSS 파일 대신, styled-components로 스타일 적용
    // backgroundImageUrl을 props로 전달
    <SplashContainer 
      $backgroundImageUrl={backgroundImageUrl}
      $isLoaded={isImageLoaded}
    >
      <LoadingBarContainer>
        <LoadingBarFill />
      </LoadingBarContainer>
      <LoadingText>Loading...</LoadingText>
    </SplashContainer>
  );
};

export default SplashScreen;
